/**
 * Ensures that an array contains exactly one item, throwing an error if not
 * @param array - The array to check
 * @returns the single item in the array
 * @throws Error if the array doesn't contain exactly one item
 */
export function getSingle<T>(array: T[]): T {
  if (array.length !== 1) {
    throw new Error('Array must contain exactly one item');
  }

  return array[0];
}

/**
 * Gets the single item from an array if it contains exactly one item, undefined otherwise
 * @param array - The array to check
 * @returns the single item if array has exactly one item and undefined when it is empty
 * @throws Error if the array contains more than one item
 */
export function getSingleOrDefault<T>(array: T[]): T | undefined {
  if (array.length > 1) {
    throw new Error('Array must contain exactly one item or should be empty');
  }

  return array.length === 1 ? array[0] : undefined;
}

/**
 * Safely gets the single item from an array without throwing errors
 * @param array - The array to check
 * @returns the single item if array has exactly one item, undefined otherwise
 */
export function tryGetSingle<T>(array: T[]): T | undefined {
  return array.length === 1 ? array[0] : undefined;
}
